import React, {useState} from "react";
import cn from "classnames";
import {useTextStyles} from "@rescui/typography";

export function CustomQrControls({amount, uploadFor}: {amount: number; uploadFor: (key: string) => React.ChangeEventHandler<HTMLInputElement>}) {
  const [isCustomQrOpen, setIsCustomQrOpen] = useState(false);
  const textCn = useTextStyles();
  return (
    <>
      <span
        className={cn("label", "collapsible-label", {
          open: isCustomQrOpen,
          closed: !isCustomQrOpen,
        })}
        onClick={() => setIsCustomQrOpen((v) => !v)}
      >
        <span>Custom QR Code</span>
        <span>{isCustomQrOpen ? "▲" : "▼"}</span>
      </span>
      {isCustomQrOpen && (
        <div className="qr-selector">
          {Array.from({length: amount}, (_, i) => {
            const slot = i + 1;
            const inputId = `custom-qr-upload-${slot}`;
            const imageKey = `custom-qr-${slot}`;
            return (
              <div className="custom-qr-upload" key={inputId}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={uploadFor(imageKey)}
                  style={{display: "none"}}
                  id={inputId}
                />
                <label htmlFor={inputId} className="bg-button upload-button">
                  <span>Upload QR {slot}</span>
                </label>
              </div>
            );
          })}
          <div className={cn("qr-generator-wrapper", "toolbar-row", textCn("rs-text-2"))}>
            <a
              className={cn(
                "qr-generator-link",
                textCn("rs-link", {external: true, mode: "standalone"})
              )}
              href={"https://mari.europe-north1-gke.intellij.net/"}
              target={"_blank"}
              rel="noopener noreferrer"
            >
              {"Open QR Generator"}
            </a>
          </div>
        </div>
      )}
    </>
  );
}
